import './title3.css'
export default function Title3(){
    return(
        <>
        <div className="h"><div className="head-3">
        </div></div>
        <div className="t">
        <h3 className='t-1'>Concentrated Flavors (Powder)</h3>
        </div>
        </>
    )
}